import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import $ from "jquery";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";
import axios from 'axios';

const ViewCommission = () => {
  const baseUrl = process.env.REACT_APP_BASEURL1;
const [data,setData] = useState([]);
const [de,setDe] = useState(0);
  useEffect(() => {
    getCommission();
  }, [de]);
  const getCommission = async()=>{
      await axios.get(`${baseUrl}/admin/commission/getCommission`).then((res)=>{
        console.log(res);
        if(res.data.success===1){
          const sortedData = res.data.data.sort((a, b) => parseFloat(a.coinStart) - parseFloat(b.coinStart));
          setData(sortedData);
        }else {
          toast.error(res.data.message);
        }
      }).catch((err)=>toast.error(err.message));
  }
  // Logic to paginate the users

  const handleConfirmDelete= async (id)=>{ // niru - 26/2
    axiosInstance.delete(`${baseUrl}/admin/commission/deletecommission/${id}`).then((res)=>{
      if (res.data.success === 1) {
        toast.success(res.data.message);
        setDe(de+1);
      } else {
        toast.error(res.data.message);
      }
    }).catch((e)=>{
      toast.error(e.message);
    });
  };
  return (
    <>
      <section className="content-header">
        <h1>Manage Commission</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Manage Commission</li>
        </ol>
      </section>
      {/* Main content */}
      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-header">
                <h3 className="box-title">
                  <Link
                    to="/admin/addcommission"
                    style={{ fontSize: "14px" }}
                    className="btn btn-block btn-success btn-xs"
                  >
                    Add More Commission
                  </Link>
                </h3>
              </div>
              {/* Box Body */}
              <div className="box-body" style={{ padding: 0 }}>
                <div className="row " style={{ padding: "16px 0px" }}>
                  <div className="entries-per-page col-md-6 ">
                  </div>
                </div>

                {/* Table */}
                <table
                  id="example1"
                  className="table table-bordered table-striped"
                  style={{ marginBottom: 0 }}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr.</th>
                      <th style={{ textAlign: "center" }}>Coin Start</th>
                      <th style={{ textAlign: "center" }}>Coin End</th>
                      <th style={{ textAlign: "center" }}>Target Commission(USD)</th>
                      <th style={{ textAlign: "center" }}>Extra Commission(USD)</th>
                      <th style={{ textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                  {
                    data.length===0?<>Loading ...</>:<tbody id="ts">
                    {Array.isArray(data) &&
                      data.map((item, index) => {
        
                        return (
                          <tr className="text-center">
                            <td>{index+1}</td>
                            <td>{item?.coinStart}</td>
                            <td>{item?.coinEnd}</td>
                            <td>{item?.targetCommission}</td>
                            <td>{item?.extraCommission}</td>
                            
                            <td>
                              <ul
                                className="admin-action btn btn-default"
                                style={{
                                  backgroundColor: "#f4f4f4",
                                  color: "#fff !important",
                                }}
                              >
                                <li class="dropdown">
                                  <a
                                    className="dropdown-toggle"
                                    style={{ color: "black" }}
                                    data-toggle="dropdown"
                                    href="#"
                                    aria-expanded="false"
                                  >
                                    Action  
                                  </a>
                                  <ul className="dropdown-menu dropdown-menu-right">
                                    <li role="presentation">
                                      <Link
                                        role="menuitem"
                                        tabIndex={-1}
                                        onClick={() => {
                                          const confirmDelete = window.confirm(
                                            "Are you sure you want to delete this item?"
                                          );
                                          if (confirmDelete) {
                                            handleConfirmDelete(item._id);
                                            // $.ajax({
                                            //   url: `https://mastishortss.com/video/admin/commission/deletecommission/${item._id}`,
                                            //   type: "delete",
                                            //   dataType: "json",
                                            //   success: function (res) {
                                            //     if (res.success === 1) {
                                            //       toast.success(res.message);
                                            //       setDe(de+1);
                                            //     } else {
                                            //       toast.error(res.message);
                                            //     }
                                            //   },
                                            // });
                                          }
                                        }}
                                      >
                                        Delete
                                      </Link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        );
                      })}
                    {/* Table Body Content */}
                  </tbody>
                  }
                  
                </table>
                {/* Pagination */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewCommission;
